import apiClient from '../client'
import type {
  RestrictedZoneDetail,
  RestrictedZoneFeatureCollection,
  RestrictedZoneSyncStatus,
} from '../models/response/restrictedZoneIntel'

const BASE_PATH = '/intelligence/restricted-zones'

export const restrictedZonesIntelService = {
  async byBbox(params: {
    minLng: number
    minLat: number
    maxLng: number
    maxLat: number
    source?: 'Ingemmet' | 'Sernanp' | 'CulturaSigda'
    layer?: string
    limit?: number
  }): Promise<RestrictedZoneFeatureCollection> {
    return apiClient.get<RestrictedZoneFeatureCollection>(`${BASE_PATH}/by-bbox`, params)
  },

  async syncStatus(): Promise<RestrictedZoneSyncStatus> {
    return apiClient.get<RestrictedZoneSyncStatus>(`${BASE_PATH}/sync-status`)
  },

  async getById(id: string): Promise<RestrictedZoneDetail> {
    return apiClient.get<RestrictedZoneDetail>(`${BASE_PATH}/${id}`)
  },
}
